import "../css/style.scss"

// Our modules / classes
//import MobileMenu from "./modules/MobileMenu"
//import HeroSlider from "./modules/HeroSlider"
import CusbarDesktopSlider from "./modules/CusbarDesktopSlider"

// Instantiate a new object using our modules/classes
//const mobileMenu = new MobileMenu()
//const heroSlider = new HeroSlider()
const cusbardesktopSlider = new CusbarDesktopSlider()
